import ExcelJS from 'exceljs'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {Button, Col, Container, Row, Stack} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import {useDropzone} from 'react-dropzone'
import {useUserInfo} from 'src/app/routing/store/InfoUserProvider'
import {KTIcon} from '../../../../../_metronic/helpers'
import {fichasxid, getCompleteSheet} from '../../../../services/fichas'
import {updateWSeleccion} from '../../../../services/wseleccion'
import {showInfoHtml, showMessage} from '../../../../shared/Alerts'
import {DataUser} from '../../../documentacion/MiFicha/DataUserInterface'
import OverlayLoading from '../../../generales_component/OverlayLoading'
import {Field, Section} from '../../fichas/Sheet'
import {PartnerContext} from '../PartnerContexts'
import './styles.css'

function findEmailAndIDsDuplicates(elements: Record<string, any>[]): [string[], string[]] {
  const seenIDs = new Set<string>()
  const IDsduplicates = new Set<string>()
  const seenEmail = new Set<string>()
  const emailduplicates = new Set<string>()

  elements.forEach((item) => {
    if (item.CS_EmailPersonal) {
      if (seenEmail.has(item.CS_EmailPersonal)) {
        emailduplicates.add(item.CS_EmailPersonal)
      } else {
        seenEmail.add(item.CS_EmailPersonal)
      }
    }

    if (item.CS_EmailPersonal) {
      if (seenIDs.has(item.CS_Documento)) {
        IDsduplicates.add(item.CS_Documento)
      } else {
        seenIDs.add(item.CS_Documento)
      }
    }
  })

  return [Array.from(IDsduplicates), Array.from(emailduplicates)]
}

function quitarTildes(texto: string) {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const ShowCargaEdicionExcelModalForm: React.FC = () => {
  const {
    setShowCargaEdicionExcelModal,
    sheet_id,
    setSheetId,
    sheet,
    setSheet,
    setRefresh,
    processId,
  } = useContext(PartnerContext)

  const {procesosAdmin, unidadesAdmin} = useUserInfo()
  const processSelectedInContext = useMemo(() => processId.split(','), [processId])
  const processToShow = useMemo(
    () =>
      processSelectedInContext.includes('all')
        ? procesosAdmin
        : procesosAdmin?.filter((p) => processSelectedInContext.includes(p.id)),
    [processSelectedInContext, procesosAdmin]
  )
  const processData = useMemo(() => {
    return processToShow.map((x) => ({label: x.name, value: x.id}))
  }, [processToShow])

  const [file, setFile] = useState<File | null>(null)
  const [rol, setRol] = useState('POST')
  const [estado, setEstado] = useState('')
  const [tipo, setTipo] = useState('')
  const [idproceso, setIdproceso] = useState('')
  const [idunidad, setIdunidad] = useState('')
  const [fileValido, setFileValido] = useState(false)
  const [arrayObjectCampos, setArrayObjectCampos] = useState<any[]>([])
  const [arrayObjectAssing, setArrayObjectAssing] = useState<any[]>([])

  const [cargandoData, setCargandoData] = useState(false)
  // const [processData, setProcessData] = useState([])
  const usuarioJSON = localStorage.getItem('userData')
  let usuario: DataUser | null = null

  if (usuarioJSON !== null) {
    usuario = JSON.parse(usuarioJSON)
  }

  useEffect(() => {
    if (sheet_id) {
      getProcessSheet(sheet_id)
    }
  }, [sheet_id])

  useEffect(() => {
    readFile()
  }, [file])

  const onDrop = (acceptedFiles: File[]) => {
    setFile(acceptedFiles[0] || null)
  }

  const readFile = async () => {
    if (file && idproceso !== '' && idunidad !== '') {
      setCargandoData(true)
      const datErroneo: {celda: string; value: string}[] = []
      const arraySeccion: string[] = []
      const arrayHeader: string[] = []
      const arrayHeaderAssing: string[] = []
      const arrayHeaderType: string[] = []
      const arrayHeaderOption: any[] = []
      const arrayHeaderOptionBD: any[] = []
      const arrayObjectCamposAux: any[] = []
      const arrayObjectAssingAux: any[] = []
      const workbook = new ExcelJS.Workbook()
      const reader = new FileReader()

      reader.onload = async (e: any) => {
        const arrayBuffer = e.target.result
        await workbook.xlsx.load(arrayBuffer)
        // Supongamos que el archivo Excel tiene una sola hoja
        const worksheet = workbook.getWorksheet(1)
        // Accede a los datos de la hoja y procesa según tus necesidades
        worksheet.eachRow((row, rowNumber) => {
          const obj: {[key: string]: string} = {}
          const obj2: {[key: string]: string} = {}
          const lastColumnNumber = row.cellCount
          row.eachCell((cell, colNumber) => {
            let exist = false
            if (rowNumber === 2) {
              arraySeccion.push(cell.text)
            }
            if (rowNumber === 3) {
              sheet.sections?.forEach((section: Section) => {
                section.fields?.forEach((field: Field) => {
                  if (
                    String(field.name) === String(cell.text) &&
                    String(section.name) === String(arraySeccion[colNumber - 1])
                  ) {
                    arrayHeader.push(cell.text)
                    String(field.type?.[0].identificador) === 'dropdownlist'
                      ? arrayHeaderOption.push(field.options?.map((e) => e.label))
                      : arrayHeaderOption.push([])

                    if (field.type?.[0].identificador === 'dropdownlist_db') {
                      console.log(field.tablaData)
                      if (field.collectionName?.toLowerCase() === 'unidades') {
                        console.log(unidadesAdmin)
                        arrayHeaderOptionBD.push(unidadesAdmin.map((e) => e.id))
                      } else if (field.collectionName?.toLowerCase() === 'nominas') {
                        arrayHeaderOptionBD.push(field.tablaData[0]?.value.map((e) => e.id))
                      } else {
                        arrayHeaderOptionBD.push(field.tablaData[0]?.value.map((e) => e.id))
                      }
                    } else {
                      arrayHeaderOptionBD.push([])
                    }
                    //TODO caso sea de unidades solo pushear las opciones que tiene asignado el admin
                    // String(field.type?.[0].identificador) === 'dropdownlist_db'
                    //   ? arrayHeaderOptionBD.push(
                    //       field.tablaData[0]?.value.map(
                    //         e => quitarTildes(e.name).toUpperCase()
                    //       )
                    //     )
                    //   : arrayHeaderOptionBD.push([])

                    arrayHeaderType.push(
                      field.type?.[0].identificador
                        ? String(field.type?.[0].identificador)
                        : 'textbox'
                    )
                    arrayHeaderAssing.push(field.assignedTo ? field.assignedTo : String(colNumber))
                    exist = true
                  }
                })
              })
              if (!exist) {
                if (cell.text !== 'Fecha Solicitud') {
                  datErroneo.push({
                    celda: getExcelLetter(colNumber) + ':' + rowNumber,
                    value: cell.text,
                  })
                }
              }
            }
            // const isLastCell = colNumber === lastColumnNumber
            // Validando Campos
            if (rowNumber > 3) {
              /*               if (isLastCell) {
                              if (cell.type === ExcelJS.ValueType.Date) {
                                const fechaExcel = cell.value as Date
                                const fechaFormateada = fechaExcel.toISOString().split('T')[0]
                                obj2['fechaRegistro'] = fechaFormateada
                              } else {
                                const fechaIngresoString = cell.value
                                console.log("fechaIngresoString")
                                console.log(fechaIngresoString)
                                if (
                                  fechaIngresoString != null &&
                                  fechaIngresoString !== undefined &&
                                  typeof fechaIngresoString === 'string'
                                ) {
                                  const partesFecha = fechaIngresoString.split('/')
                                  const dia = Number(partesFecha[0])
                                  const mes = Number(partesFecha[1])
                                  const año = Number(partesFecha[2])
                                  const fechaIngreso = new Date(año, mes - 1, dia)
                                  const fechaFormateada = fechaIngreso.toISOString().split('T')[0]
                                  console.log("aqui1")
                                  // Verifica si la fecha es válida
                                  if (!isNaN(fechaIngreso.getTime())) {
                                    obj2['fechaRegistro'] = fechaFormateada
                                  } else {
                                    datErroneo.push({
                                      celda: getExcelLetter(colNumber) + ':' + rowNumber,
                                      value: cell.text,
                                    })
                                    console.log('Fecha no válida')
                                  }
                                } else {
                                  datErroneo.push({
                                    celda: getExcelLetter(colNumber) + ':' + rowNumber,
                                    value: cell.text,
                                  })
                                  console.log('El valor de la celda es null o undefined')
                                }
                              }
                            } else { */
              if (cell.type === ExcelJS.ValueType.Date) {
                const fechaExcel = cell.value as Date
                const fechaFormateada = fechaExcel.toISOString().split('T')[0]
                obj[arraySeccion[colNumber - 1] + '_' + arrayHeader[colNumber - 1]] =
                  fechaFormateada
                obj2[arrayHeaderAssing[colNumber - 1]] = fechaFormateada
              } else {
                if (arrayHeaderType[colNumber - 1] === 'date') {
                  const fechaIngresoString = cell.value
                  // Verifica si fechaIngresoString no es null ni undefined
                  if (
                    fechaIngresoString != null &&
                    fechaIngresoString !== undefined &&
                    typeof fechaIngresoString === 'string'
                  ) {
                    const partesFecha = fechaIngresoString.split('/')
                    const dia = Number(partesFecha[0])
                    const mes = Number(partesFecha[1])
                    const año = Number(partesFecha[2])
                    const fechaIngreso = new Date(año, mes - 1, dia)
                    const fechaFormateada = fechaIngreso.toISOString().split('T')[0]

                    // Verifica si la fecha es válida
                    if (!isNaN(fechaIngreso.getTime())) {
                      obj[arraySeccion[colNumber - 1] + '_' + arrayHeader[colNumber - 1]] =
                        fechaFormateada
                      obj2[arrayHeaderAssing[colNumber - 1]] = fechaFormateada
                    } else {
                      datErroneo.push({
                        celda: getExcelLetter(colNumber) + ':' + rowNumber,
                        value: cell.text,
                      })
                      console.log('Fecha no válida')
                    }
                  } else {
                    datErroneo.push({
                      celda: getExcelLetter(colNumber) + ':' + rowNumber,
                      value: cell.text,
                    })
                    console.log('El valor de la celda es null o undefined')
                  }
                } else if (arrayHeaderType[colNumber - 1] === 'dropdownlist') {
                  obj[arraySeccion[colNumber - 1] + '_' + arrayHeader[colNumber - 1]] = cell.text
                  obj2[arrayHeaderAssing[colNumber - 1]] = cell.text
                  const exist = arrayHeaderOption[colNumber - 1].includes(cell.text)
                  if (!exist) {
                    datErroneo.push({
                      celda: getExcelLetter(colNumber) + ':' + rowNumber,
                      value: cell.text,
                    })
                  }
                } else if (arrayHeaderType[colNumber - 1] === 'dropdownlist_db') {
                  obj[arraySeccion[colNumber - 1] + '_' + arrayHeader[colNumber - 1]] = cell.text
                  obj2[arrayHeaderAssing[colNumber - 1]] = cell.text
                  console.log('arrayHeaderOptionBD')
                  console.log(arrayHeaderOptionBD)
                  const exist = arrayHeaderOptionBD[colNumber - 1].includes(
                    quitarTildes(String(cell.text)).toUpperCase()
                  )
                  if (!exist) {
                    datErroneo.push({
                      celda: getExcelLetter(colNumber) + ':' + rowNumber,
                      value: cell.text,
                    })
                  }
                } else {
                  obj[arraySeccion[colNumber - 1] + '_' + arrayHeader[colNumber - 1]] = cell.text
                  obj2[arrayHeaderAssing[colNumber - 1]] = cell.text
                }
              }
              // }
            }
          })
          if (rowNumber > 3) {
            arrayObjectCamposAux.push(obj)
            const stringProps: {[key: string]: string} = {}
            for (const key in obj2) {
              if (isNaN(parseInt(key))) {
                // Verifica si el nombre de la propiedad es un número en formato de cadena.
                stringProps[key] = obj2[key] // Almacena la propiedad en el nuevo objeto.
              }
            }
            arrayObjectAssingAux.push(stringProps)
          }
        })

        const [duplicatesIDs, duplicatesEmail] = findEmailAndIDsDuplicates(arrayObjectAssingAux)
        if (datErroneo.length === 0 && (duplicatesIDs.length > 0 || duplicatesEmail.length > 0)) {
          const titleIDs = duplicatesIDs.length > 0 ? 'Documentos duplicados' : ''
          const titleEmail = duplicatesEmail.length > 0 ? 'Emails duplicados' : ''
          const both = duplicatesIDs.length > 0 && duplicatesEmail.length > 0
          const title = both ? `${titleIDs} y ${titleEmail}` : titleIDs || titleEmail

          const IDsHTML =
            duplicatesIDs.length > 0
              ? `
            Se encontraron ${duplicatesIDs.length} documentos duplicados,
            por favor verifique los campos que sean correctos <br/><br/>
            ${duplicatesIDs
              .map((id) => `<p style="margin:6px;">Nro. Documento: ${id}</p>`)
              .join('')}
          `
              : ''
          const emailsHTML =
            duplicatesEmail.length > 0
              ? `
            Se encontraron ${duplicatesEmail.length} emails duplicados,
            por favor verifique los campos que sean correctos <br/><br/>
            ${duplicatesEmail.map((email) => `<p style="margin:6px;">Email: ${email}</p>`).join('')}
          `
              : ''

          const msg = '<br/> Corrija los datos y vuelve a cargar el excel'

          const html = both
            ? `${IDsHTML} <br/><br/> ${emailsHTML} ${msg}`
            : (IDsHTML || emailsHTML) + msg

          showInfoHtml('error', title, html)
          setCargandoData(false)
          return
        }

        if (datErroneo.length > 0) {
          setCargandoData(false)
          let codigoHTML = ''
          codigoHTML += `Se encontraron campos que no son admisibles, Verificar los campos que sean correctos <br/>
                              <div class="centrar-tabla" >
                              <table border="1">
                              <thead>
                                  <tr>
                                    <th>Celda</th>
                                    <th>Campos</th>
                                  </tr>
                              </thead>
                              <tbody> `
          for (const dat of datErroneo) {
            codigoHTML += '<tr><td>' + dat.celda + '</td><td>' + dat.value + '</td></tr>'
          }
          codigoHTML += '</tbody> </table> </div>'
          showInfoHtml('info', 'Campos no admisible', codigoHTML)
        } else {
          setCargandoData(false)
          setFileValido(true)
          setArrayObjectAssing(arrayObjectAssingAux)
          setArrayObjectCampos(arrayObjectCamposAux)
        }
      }
      reader.readAsArrayBuffer(file)
    } else if (idproceso === '') {
      showMessage('info', 'Seleccionar Campo', 'debe seleccionar Proceso')
    } else if (idunidad === '') {
      showMessage('info', 'Seleccionar Campo', 'debe seleccionar Unidad')
    }
  }

  const saveExcel = async () => {
    if (idunidad !== '' && idproceso !== '') {
      setCargandoData(true)
      await updateWSeleccion(
        {
          Campos: arrayObjectCampos,
          Assing: arrayObjectAssing,
        },
        idproceso,
        idunidad
      )
        .then((response) => {
          if (response.success) {
            if (response.notuser) {
              showInfoHtml(
                'error',
                'No se cargo la Plantilla',
                `
                    <p>${response.message}</p>  
                  `
              )
              setCargandoData(false)
            } else {
              showInfoHtml(
                'success',
                'Registro Correctamente',
                `
                    <p>${response.message}</p>  
                  `
              )
              setCargandoData(false)
              setRefresh(true)
            }
          } else {
            showMessage('error', 'Hubo un Error', response.message)
            setCargandoData(false)
            setRefresh(true)
          }
        })
        .catch((error) => {
          console.log(error)
          setCargandoData(false)
        })
      setShowCargaEdicionExcelModal(false)
    }
  }

  const getExcelLetter = (number: number) => {
    let result = ''
    while (number > 0) {
      const remainder = (number - 1) % 26
      result = String.fromCharCode(65 + remainder) + result
      number = Math.floor((number - 1) / 26)
    }
    return result
  }

  const getProcessSheet = (id: string) => {
    getCompleteSheet(id)
      .then((response) => {
        setSheet(response.data)
      })
      .catch((error) => console.log(error))
  }

  // const refetchDataProcesos = () => {
  //   const options = {
  //     responsables: usuario?.userId,
  //   }
  //   getProceso(1, 100, options).then((response) => {
  //     if (response.success) {
  //       setProcessData(
  //         response.data
  //           .map((x: any) => ({label: x.nombre, value: x._id}))
  //           .filter((r: any) => r.value === processId)
  //       )
  //       handleInputDefault()
  //     } else {
  //       console.log(response.msg)
  //     }
  //   })
  // }

  const handleInputChange = (event: any) => {
    setIdproceso(event.target.value)
  }

  const handleInputDefault = () => {
    setIdproceso(processId)
  }

  const handleInputChangeUnidad = (event: any) => {
    setIdunidad(event.target.value)
  }

  const handleStateChange = (e: any) => {
    setEstado(e.target.value)
  }

  const handleChangeTipo = (e: any) => {
    setTipo(e.target.value)
  }

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'application/xlsx': ['.xlsx'],
    },
    maxFiles: 1,
  })

  const sheetName = useMemo(() => `Cargar Excel de la Ficha ${sheet?.name || ''}`, [sheet])

  const getFichasxProceso = (value: string) => {
    fichasxid(value).then((response) => {
      if (response.success) {
        setSheetId(response?.data?.[0]?.idficha?._id)
        // setNameficha(`Cargar Excel de la Ficha ${response.data[0]?.idficha?.nombre}`)
        // setSheet(response.data)
      } else {
        console.log(response.msg)
      }
    })
  }

  useEffect(() => {
    if (idproceso !== '') {
      getFichasxProceso(idproceso)
    }
  }, [idproceso])

  useEffect(() => {
    return () => {
      setSheetId('')
    }
  }, [])

  return (
    <>
      <Container className='mt-1'>
        <Row>
          <Row>
            <Col className='mb-6'>
              <span className='fw-bold'>Proceso</span>
              <Stack className=' mt-3' direction='horizontal' gap={3}>
                <select
                  className='form-select form-select-solid'
                  aria-label='Select example'
                  value={idproceso}
                  name='idproceso'
                  onChange={(event) => handleInputChange(event)}
                >
                  {processData.map((x: any) => (
                    <option value={x.value}> {String(x.label)}</option>
                  ))}
                </select>
              </Stack>
            </Col>
            <Col className='mb-6'>
              <span className='fw-bold'>Unidad</span>
              <Stack className=' mt-3' direction='horizontal' gap={3}>
                <select
                  className={'form-select form-select-solid}'}
                  aria-label='Select example'
                  value={idunidad}
                  name='idunidad'
                  onChange={(event) => handleInputChangeUnidad(event)}
                >
                  <option value=''>Seleccionar</option>
                  {unidadesAdmin.map((x) => (
                    <option value={x.id} key={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </Stack>
            </Col>
          </Row>

          {/* <Col className='mb-6' >
                  <span className='fw-bold'>Ficha</span>
                  <Stack className=' mt-3' direction='horizontal' gap={3}>
                  <Form.Select style={{marginLeft:'50px'}} >
                    <option value='1'>Ficha Empleado</option>
                  </Form.Select>
                  </Stack>
                </Col> */}
        </Row>
        <Row>
          <Col sm={12}>
            <div className=''>
              {
                <div>
                  <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
                    <input {...getInputProps()} />
                    <p>
                      Arrastra el archivo aquí <br /> o <br />{' '}
                      <Button type='button' className='btn-sm btn-success'>
                        {' '}
                        Seleccionar Archivo
                      </Button>
                    </p>
                  </div>
                  <div className='dropzone-preview-container'>
                    <div className='dropzone-preview2'>
                      {file?.name && fileValido ? (
                        <div className='d-flex align-items-center justify-content-between'>
                          <KTIcon iconName='file-sheet' className='fs-3 text-primary me-3' />
                          <div className='flex-grow-1 text-start'>
                            <span className='d-block text-primary fw-bold'>
                              Nombre del archivo: {file.name}
                            </span>
                            <hr className='m-0 mt-1 text-primary' />
                          </div>
                          <KTIcon iconName='check-circle' className='fs-3 ms-3 text-success' />
                        </div>
                      ) : (
                        <div className='d-flex align-items-center justify-content-between'>
                          <KTIcon iconName='file-sheet' className='fs-3 text-primary me-3' />

                          <div className='flex-grow-1 text-start'>
                            <span className='d-block text-primary fw-bold'>
                              No se ha seleccionado ningun archivo
                            </span>
                            <hr className='m-0 mt-1 text-primary' />
                          </div>

                          <KTIcon iconName='plus-circle' className='fs-3 ms-3' />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              }
            </div>
          </Col>
          <Col sm={12} className='w-100 d-flex align-self-start justify-content-start '>
            <div className='alert alert-dismissible bg-light-primary border border-primary d-flex flex-column flex-sm-row p-5 mb-2 w-100'>
              <span className='svg-icon svg-icon-5hx svg-icon-primary me-4 mb-5 mb-sm-0'>
                <i className='bi bi-info-square fs-2x'></i>
              </span>
              <div className='d-flex flex-column text-primary pe-0 pe-sm-10'>
                <h5 className='mb-1'>{sheetName}</h5>
              </div>
            </div>
          </Col>
          <Col xs='auto' className='mt-4 ms-auto'>
            <button type='button' className='btn btn-success' onClick={() => saveExcel()}>
              Guardar
            </button>
          </Col>
        </Row>
      </Container>
      {cargandoData && <OverlayLoading />}
    </>
  )
}

export {ShowCargaEdicionExcelModalForm}
